export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <img className="hero--section--icon" src="./img/hero-icon-img.jpg" alt="Hero Icon Image" />
          <p className="section--title">Hallo! Mein Name ist Walid</p>
          <h1 className="hero--section--title">
            <span className="hero--section-title--color">Software</span>{" "}
            <br />
            Development Consultant
          </h1>
          <p className="hero--section-description">
            Ich liebe es, komplexe technische Ideen in verständliche,
            <br />  nutzerfreundliche Anwendungen zu verwandeln.
          </p>
        </div>
        <a href="mailto:walid.alsibai@gmail.com" className="btn btn-primary">
          Kontakt aufnehmen
        </a>      </div>
      <div className="hero--section--img">
        <img src="./img/skills-logos.png" alt="Hero Section" />
      </div>
    </section>
  );
}
